import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';

export const TieredHeader = {
  color: '$core.color.brand.100',
  fontSize: '25.63px !important',
  fontStyle: 'normal',
  lineHeight: '32px !important',
  '@media (max-width: 464px)': {
    fontSize: '20.25px !important',
    lineHeight: '24px !important',
    marginTop: '3px',
  },
};

export const TieredContentStyle = {
  color: '#4B4D4F',
  fontSize: '18px',
  fontStyle: 'normal',
  fontWeight: '500',
  lineHeight: '24px',
  '@media (max-width: 464px)': {
    fontSize: '16px',
    lineHeight: '20px',
  },
};
export const TextWrapper = styled('div', {
  maxWidth: '840px',
});

export const HeadingWrapper = styled('div', {
  display: 'inline-flex',
  marginBottom: '4px',
  '.abyss-icon': {
    margin: '2px 8px 0 0',
    '@media (max-width: 464px)': {
      margin: '0 4px 0 0',
    },
  },
});
export const TieredLinkWrapper = styled('div', {
  padding: '8px 0 8px 0',
  '@media (max-width: 464px)': {
    padding: '16px 0 0 0 !important',
  },
});

export const TieredLinkStyle = {
  color: '$core.color.brand.60',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '20px',
  '@media (max-width: 464px)': {
    fontSize: '14.22px !important',
    lineHeight: '18px',
  },
};

export const TieredDrawerStyles = {
  'abyss-modal-base-content-container': {
    borderRadius: '20px 20px 0 0',
    height: 'auto !important',
  },
  'abyss-modal-base-body': {
    margin: '16px 24px 16px 24px',
    color: '$core.color.neutral.90',
    whiteSpace: 'pre-line',
    fontSize: '16px',
    fontWeight: '500',
  },
  'abyss-modal-close-button': { margin: '8px 10px 0 0' },
  'abyss-modal-content-title': {
    paddingTop: '2px',
    fontFamily: '$primary !important',
    fontSize: '20.25px !important',
    color: '#323334 !important',
    lineHeight: '24px !important',
    fontWeight: '700 !important',
  },
  'abyss-modal-header-container': {
    padding: '16px 24px 0px 24px',
  },
};

export const BenefitsBadgeDrawerStyles = styled(Drawer, {
  '.abyss-modal-base-content-container': {
    borderRadius: '20px 20px 0 0',
    height: 'auto !important',
  },
  '.abyss-modal-base-body': {
    borderTop: '1px solid $core.color.neutral.30',
    padding: '$md',
    color: '$core.color.neutral.90',
  },
  '.abyss-modal-close-button': {
    margin: '8px 10px 0 0',
  },
  '.abyss-modal-content-title': {
    fontFamily: '$primary !important',
    fontSize: '20px !important',
    color: '$core.color.brand.100',
    lineHeight: '24px !important',
    fontWeight: 'bold !important',
  },
  '.abyss-modal-header-container': {
    padding: '0 16px 16px 16px',
  },
});
